import { render, staticRenderFns } from "./PlanSummary.vue?vue&type=template&id=8b33ab60&lang=pug"
import script from "./PlanSummary.vue?vue&type=script&lang=js"
export * from "./PlanSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,PlanComparing: require('/home/docker/code/frontend/components/PlanComparing.vue').default,PlanCompare: require('/home/docker/code/frontend/components/PlanCompare.vue').default,EnrollForm: require('/home/docker/code/frontend/components/EnrollForm.vue').default})
